import styled from 'styled-components'
import { sureco } from 'enrollment-platform/pages/finance/components/shared/finance.styles'

export const ValidationBannerContainer = styled.div<{
  $variant: 'loading' | 'warning'
}>`
  padding: 14px 18px;
  border-radius: 10px;
  margin-bottom: 24px;
  background: ${({ $variant }) =>
    $variant === 'warning' ? '#FEFCE4' : sureco.offWhite};
  border: 2px solid
    ${({ $variant }) => ($variant === 'warning' ? '#FFEE7A' : sureco.border)};
`

export const ValidationBannerBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const ValidationBannerHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ValidationBannerIcon = styled.span<{
  $variant: 'loading' | 'warning'
}>`
  display: flex;
  align-items: center;
  color: ${({ $variant }) => ($variant === 'warning' ? '#CA7C00' : sureco.fg3)};
  font-size: 12px;
`

export const ValidationBannerTitle = styled.span<{
  $variant: 'loading' | 'warning'
}>`
  font-weight: 600;
  font-size: 14px;
  color: ${({ $variant }) => ($variant === 'warning' ? '#CA7C00' : sureco.fg2)};
`

export const ValidationBannerList = styled.ul`
  margin: 0;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const ValidationBannerListItem = styled.li`
  font-size: 13px;
  margin-left: 25px;
  color: ${sureco.fg2};
`

export const ValidationBannerCount = styled.strong`
  color: #e3000e;
  font-weight: 700;
`
